import React, { useEffect, useState } from "react";
// import Joke from "./Joke";
// import jokesData from "./jokesData";
// import Form from "./Form";
// import Header from "./components/Header";
// import Meme from "./components/Meme";
//import WindowTracker from "./components/WindowTracker";
// import Navbar from "./components/Navbar";
// import Main from "./components/Main";
import Die from "./components/Die";
import { nanoid } from "nanoid";
import Confetti from "react-confetti";

export default function App() {
  const [dice, setDice] = React.useState(allNewDice());
  const [tenzies, setTenzies] = React.useState(false);
  const [rollCount, setRollCount] = useState(0);
  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);
  const [bestTime, setBestTime] = useState(null);
  const [bestCount, setBestCount] = useState(null);


  useEffect(() => {
    const isHeld = dice.every((die) => die.isHeld);
    const isSame = dice.every((die) => die.value === dice[0].value);
    if (isHeld && isSame) {
      setTenzies(true);
      setEndTime(Date.now());
      const elapsedTime = (endTime - startTime) / 1000;
    }
  }, [dice]);

  const bestTimeMinutes = bestTime ? Math.floor(bestTime / 60) : null;
const bestTimeSeconds = bestTime ? Math.floor(bestTime % 60) : null;

  useEffect(() => {
    if (tenzies) {
      if (bestTime === null || elapsedTime < bestTime) {
        setBestTime(elapsedTime);
      }
      if (bestCount === null || rollCount < bestCount) {
        setBestCount(rollCount);
      }
    }
  }, [tenzies, bestTime, startTime, endTime]);

  function generateDice() {
    return {
      value: Math.ceil(Math.random() * 6),
      isHeld: false,
      id: nanoid(),
    };
  }

  function allNewDice() {
    const newDice = [];
    for (let i = 0; i < 10; i++) {
      newDice.push(generateDice());
    }
    return newDice;
  }

  function rollDice() {
    if (!startTime) {
      setStartTime(Date.now());
    }
    setDice((oldDice) =>
      oldDice.map((die) => {
        return die.isHeld ? die : generateDice();
      })
    );
    setRollCount(rollCount + 1);
  }

  function holdDice(id) {
    setDice((oldDice) =>
      oldDice.map((die) => {
        return die.id === id ? { ...die, isHeld: !die.isHeld } : die;
      })
    );
  }

  function reset() {
    setDice(allNewDice());
    setTenzies(false);
    setStartTime(null);
    setEndTime(null);
    setRollCount(0);
  }

  const diceElements = dice.map((die) => (
    <Die
      key={die.id}
      value={die.value}
      isHeld={die.isHeld}
      holdDice={() => holdDice(die.id)}
    />
  ));

  //Time to finish the game
  const elapsedTime = startTime && endTime ? (endTime - startTime) / 1000 : null;
  const minutes = elapsedTime ? Math.floor(elapsedTime / 60) : null;
  const seconds = elapsedTime ? Math.floor(elapsedTime % 60) : null;

  //best time to finish the game
 

  return (
    <main>
      {tenzies && <Confetti />}
      <h1 className="title">Tenzies</h1>
      <p className="instructions">
        Roll until all dice are the same. Click each die to freeze it at its
        current value between rolls.
      </p>
      {tenzies && elapsedTime && (
        <p>
          Your elapsed time to win the game is {minutes} minutes and {seconds}{" "}
          seconds
        </p>
      )}
      {tenzies && <p>Your total roll count to win the game is {rollCount}</p>}
      {tenzies && <p>The best time anyone has ever won the game is {bestTimeMinutes} minutes and {bestTimeSeconds} seconds</p>}
      {tenzies && <p>Your best roll count to win the game is {bestCount}</p>}
      <div className="die-container">{diceElements}</div>
      <button className="roll-dice" onClick={tenzies ? reset : rollDice}>
        {tenzies ? "New Game" : "Roll"}
      </button>
    </main>
  );

  //12. Toggle dark mode on switch goes here
  //   const [isDarkMode, setIsDarkMode] = React.useState(true);

  //   function toggleDarkMode() {
  //     setIsDarkMode(prevMode => !prevMode)
  //   }

  //   return (
  //     <div className="container">
  //       {<Navbar
  //         darkMode = {isDarkMode}
  //         toggleDarkMode = {toggleDarkMode}
  //       />}
  //       {<Main
  //         darkMode={isDarkMode}
  //       />}
  //     </div>
  //   );
  //Toggle dark mode on switch goes here

  //11. Toggle window width display and the screen resize update (State and effect practice) goes here
  // return (
  //   <div className="container">
  //     <WindowTracker />
  //   </div>
  // );
  //Toggle window width display and the screen resize update (State and effect practice) goes here

  //9. useEffect: using button to update the API content(Get next character) starts here
  // const [starWarsData, setStarWarsData] = React.useState({})
  // const [count, setCount] = React.useState(1)

  // React.useEffect(function() {
  //     console.log("Effect ran")
  //     fetch(`https://swapi.dev/api/people/${count}`)
  //         .then(res => res.json())
  //         .then(data => setStarWarsData(data))
  // }, [count])

  // return (
  //     <div>
  //         <h2>The count is {count}</h2>
  //         <button onClick={() => setCount(prevCount => prevCount + 1)}>Get Next Character</button>
  //         <pre>{JSON.stringify(starWarsData, null, 2)}</pre>
  //     </div>
  // )
  // useEffect: using button to update the API content(Get next character) ends here

  //8. Usestate in API call starts here
  //   const [starWarsData, setStarWarData] = React.useState({})
  //   const [count, setCount] = React.useState(0)
  //   React.useEffect(() => {
  //     fetch('https://swapi.dev/api/people/1/')
  //      .then((response) => response.json())
  //      .then(data => setStarWarData(data))
  //   }, [])

  //   console.log(starWarsData)
  //   function addCount() {
  //     setCount(count + 1)
  //   }
  // return (
  //   <div>
  //     <pre>{JSON.stringify(starWarsData, null, 2)}</pre>
  //     <p>The count is {count}</p>
  //     <button onClick ={addCount}>Add</button>
  //   </div>
  // )
  //Usestate in API call ends  here

  //7. Making API calls starts here

  // const [starWarsData, setStarWarsData] = React.useState({})

  // console.log("Component rendered")

  // fetch("https://swapi.dev/api/people/1")
  //     .then(res => res.json())
  //     .then(data => setStarWarsData(data))

  // return (
  //     <div>
  //         <pre>{JSON.stringify(starWarsData, null, 2)}</pre>
  //     </div>
  // )

  //Making API calls ends here

  //10. Displaying meme image and text starts here
  // return (
  //   <div>
  //       <Header />
  //       <Meme />
  //   </div>
  // )
  //Displaying meme image and text ends here

  //6. Form- Change firstname and lastname state ---Forms state object starts here
  //return <Form />
  //Form- Change firstname and lastname state ---Forms state object ends here

  // 5. Form component starts here

  // Form component ends here

  // 4. Displaying no of unread msg text using conditional rendering starts here
  // const [messages, setMessages] = React.useState(["rag", "sumi"])
  // const noMessageText = "You're all caught up!"
  // const unreadMessageText = "You have <n> unread message(s)"
  // return (
  //     <div>
  //     {messages.length===0 ?
  //     <h1>You're all caught up!</h1> :
  //     <h1>You have {messages.length} unread {messages.length > 1 ? "messages" : "message"}.</h1>
  //     }
  //     </div>
  // )
  // Displaying no of unread msg text using conditional rendering ends here

  //3. Conditional rendering: Ternary operator starts here
  //   const jokeElements = jokesData.map((joke) => {
  //     return (
  //     <Joke
  //     key={joke.id}
  //     setup={joke.setup}
  //     punchline={joke.punchline}
  //     />
  //     )
  //   });
  //   return<div>{jokeElements}</div>
  //Conditional rendering: Ternary operator ends here
  //   2. Conditional rendering to display message starts here
  //   const newArray = ["ragish", "Sumi"];
  //   return <div>{newArray.length>0 && `You have ${newArray.length} new messages.`}</div>
  //   Conditional rendering to display message starts here

  // 1. Toggle punchline joke : Joke component starts here
  // const [isShown, setIsShown] = React.useState(false)
  // function toggleShown(){
  //     setIsShown(prevShown => !prevShown)
  // }
  // const jokeElements = jokesData.map(joke => {
  //     return (
  //         <Joke
  //             key={joke.id}
  //             setup={joke.setup}
  //             punchline={joke.punchline}
  //             toggleShown = {toggleShown}
  //             isShown={isShown}
  //         />
  //     )
  // })
  // return (
  //     <div>
  //         {jokeElements}
  //     </div>
  // )
  // Joke component ends here

  //10. Get memes from an API code here -- This is a return code for no. 10 tasks in Meme.js
  // return(
  //   <div>
  //     <Header />
  //     <Meme />
  //   </div>
  // )
  //Get memes from an API code here -- This is a return code for no. 10 tasks in Meme.js
}
